import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c770bbd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "emojis-and-giphs" }
const _hoisted_2 = { class: "emojis-and-giphs-content" }
const _hoisted_3 = { class: "top" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "handle-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "handle" })
], -1))
const _hoisted_5 = { class: "switch-container" }
const _hoisted_6 = { class: "switch" }
const _hoisted_7 = { class: "switch-inner" }

import EmojisSelection from "../EmojisSelection/EmojisSelection.vue";
import GifsSelection from "../GifsSelection/GifsSelection.vue";
import { ref } from "vue";
import { SwitchType } from "@/types/cards";
import EmojisAndGiphsSwitch from "../EmojisAndGiphsSwitch/EmojisAndGiphsSwitch.vue";

interface Emits {
  (e: "insert-emoji", emoji: string): void;
  (e: "toggle-emoji-list-visibility"): void;
  (e: "insert-gif", url: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EmojisAndGiphs',
  emits: ["insert-emoji", "toggle-emoji-list-visibility", "insert-gif"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const hideEmoji = (e: MouseEvent) => {
  const target = e.target as HTMLElement;
  if (target.classList.contains("emoji-btn")) {
    return;
  }
  emit("toggle-emoji-list-visibility");
};

const insertEmoji = (emoji: string) => {
  emit("insert-emoji", emoji);
};

const insertGif = (url: string) => {
  emit("insert-gif", url);
};

const toggleSwitchType = (switchType: SwitchType) => {
  activeSwitchType.value = switchType;
};

const activeSwitchType = ref<SwitchType>(SwitchType.Emoji);

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_unref(SwitchType)), (switchType) => {
                return (_openBlock(), _createBlock(EmojisAndGiphsSwitch, {
                  key: switchType,
                  "active-switch-type": activeSwitchType.value,
                  "switch-type": switchType,
                  onToggleSwitchType: toggleSwitchType
                }, null, 8, ["active-switch-type", "switch-type"]))
              }), 128))
            ])
          ])
        ])
      ]),
      (activeSwitchType.value === _unref(SwitchType).Emoji)
        ? (_openBlock(), _createBlock(EmojisSelection, {
            key: 0,
            onInsertEmoji: insertEmoji
          }))
        : (_openBlock(), _createBlock(GifsSelection, {
            key: 1,
            onInsertGif: insertGif
          }))
    ])
  ])), [
    [_directive_click_outside, hideEmoji]
  ])
}
}

})